module.exports = __webpack_public_path__ + "static/media/tip_empty_state.b3d3fab8.svg";